<template lang="pug">
  #program-settings
    WtTile(ancestor)
      WtTile(class="custom-container")
        WtTile(vertical :col="7" class="custom-col-7")
          WtTile(parent v-if="isProTier")
            ProgramCustomizationNavigator
          //- TODO needs to be updated to account for legacy notes
          //- meaning legacy handles the actions differently
          //- and so the log will show different icons and descriptions
          WtTile(parent :col="12" v-if="$auth.user().isWtAdmin")
            WtTile(child :col="12")
              BNotification(
                v-if="$auth.user().isWtAdmin"
                type="is-danger"
                role="alert"
                has-icon
                icon="information"
                :closable="false"
              ) Only WT Admins Can See This Program Log
              ProgramAdminLog
          WtTile(parent :col="12")
            WtTile(child :col="12")
              GeneralSettings

          WtTile(parent :col="12")
            WtTile(child :col="12")
              Settings

          WtTile(parent :col="12")
            WtTile(child :col="12")
              RegistrationDetails

          //- [PENDING REMOVAL]
          //- this is flagged to be removed completely so commenting out until approved
          //- WtTile(parent)
            WtTile(child)
              MemberEntrySettings

        WtTile(vertical)
          WtTile(parent)
            WtTile(child)
              WelcomeCard
          WtTile(parent)
            WtTile(child)
              ActivitySettings
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import GeneralSettings from "@@/ProgramSettingsAdmin/GeneralSettings";
import RegistrationDetails from "@@/ProgramSettingsAdmin/RegistrationDetails";
import ContactInformation from "@@/ProgramSettingsAdmin/ContactInformation";
import WelcomeCard from "@@/ProgramSettingsAdmin/WelcomeCard";
import Settings from "@@/ProgramSettingsAdmin/Settings";
import MemberEntrySettings from "@@/ProgramSettingsAdmin/MemberEntrySettings";
import ActivitySettings from "@@/ProgramSettingsAdmin/ActivitySettings";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import ProgramAdminLog from "@@/ProgramSettingsAdmin/ProgramAdminLog";
import ProgramCustomizationNavigator from "@@/ProgramCustomization/ProgramCustomizationNavigator";

export default {
  name: "ProgramSettings",

  components: {
    WtButton,
    WtTitle,
    WtTile,
    GeneralSettings,
    RegistrationDetails,
    ContactInformation,
    WelcomeCard,
    Settings,
    MemberEntrySettings,
    ActivitySettings,
    ProgramAdminLog,
    ProgramCustomizationNavigator
  },

  computed: {
    ...mapGetters("program", ["isProTier"])
  },

  methods: {
    ...mapActions("program", ["resetProgramSettingsCopy"])
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.resetProgramSettingsCopy();
    });
  }
};
</script>

<style lang="sass" scoped>
.custom-container
  @media screen and (max-width: 1375px)
    flex-direction: column
.custom-col-7
  @media screen and (max-width: 1375px)
    width: 100%
</style>
